import React from "react";
import ButtonBase from "../_base/ButtonBase";
import styles from "./index.module.css";

/**
 * OutlineButton — white/outlined variant
 *
 * Additional props beyond ButtonBase:
 *  withInset      boolean    (default: false) — adds inset bottom shadow for 3D depth (SS1, SS2, SS3)
 *                            omit for flat style (SS4, SS5)
 *  labelClassName string     — class applied to the label <span> for text color overrides
 *                            e.g. pass styles.greenText to make text green
 *  divider        boolean    (default: false) — compound layout with vertical divider (SS2)
 *  rightContent   ReactNode  — content rendered right of the divider
 */
const OutlineButton = React.forwardRef(function OutlineButton(
  { withInset = false, ...props },
  ref,
) {
  const extraClass = withInset ? styles.withInset : undefined;

  return (
    <ButtonBase
      {...props}
      ref={ref}
      styles={styles}
      spinnerColor="#404040"
      className={
        [extraClass, props.className].filter(Boolean).join(" ") || undefined
      }
    />
  );
});

export default OutlineButton;
